import shortid from 'shortid';

import { ROUTES } from 'src/constants';

import { NavToolbar } from 'components/NavToolbar';

import { t } from 'utils';

function Toolbar() {
  const items = [
    { key: shortid(), path: ROUTES.couponsRoute, label: t.staticAsString('coupons.detail.nav.coupons') },
    { key: shortid(), label: t.staticAsString('coupons.detail.nav.couponDetails') },
  ];
  return (
    <div className='toolbar'>
      <NavToolbar items={items} />
    </div>
  );
}

export { Toolbar };
